// Angular
import { FormControl, FormGroup } from '@angular/forms';

export class FormHelper {
  static readonly CUSTOM_VALIDATORS = {
    NO_WHITESPACE: this.noWhitespaceValidator,
  };

  static controlHasError(form: FormGroup, controlName: string, validationType: string): boolean {
    const control = form.controls[controlName];

    if (!control) {
      return false;
    }

    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  static noWhitespaceValidator(control: FormControl) {
    return (control.value || '').trim().length ? null : { whitespace: true };
  }
}
